import {
	CreateBase,
	required,
	SimpleForm,
	TextInput,
	useCreateSuggestionContext
} from 'react-admin';
import CloseIcon from '@mui/icons-material/Close';
import {
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
	Stack
} from '@mui/material';
import { GoogleAutocompleteInput } from '../../../misc/GoogleAutocompleteInput';
import { INPUT_SOURCE } from '../../constants';
import { ComplexType } from '../../types';

export const FastCreateComplex = () => {
	const { filter, onCancel, onCreate } = useCreateSuggestionContext();

	const transform = (data: ComplexType) => ({
		...data,
		function_type: 1
	});

	const onComplexCreate = (complexName: string) => {
		onCreate(complexName);
	};

	return (
		<>
			<Dialog
				sx={{
					zIndex: 999
				}}
				open
				onClose={onCancel}
				slotProps={{
					paper: {
						sx: {
							width: 400
						}
					}
				}}
			>
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="space-between"
				>
					<DialogTitle sx={{ m: 0, p: 2 }}>Створити комплекс</DialogTitle>
					<IconButton
						aria-label="close"
						onClick={onCancel}
						sx={theme => ({
							color: theme.palette.grey[500],
							marginRight: 1
						})}
					>
						<CloseIcon />
					</IconButton>
				</Stack>
				<DialogContent sx={{ p: 0 }} dividers>
					<CreateBase
						redirect={false}
						resource="complexes"
						transform={transform}
						mutationOptions={{
							onSuccess: complexName => {
								onComplexCreate(complexName);
							}
						}}
					>
						<SimpleForm defaultValues={{ name: filter }}>
							<Stack width="100%">
								<TextInput
									source={INPUT_SOURCE.NAME}
									helperText={false}
									validate={required()}
								/>
								<GoogleAutocompleteInput isRequired={true} />
							</Stack>
						</SimpleForm>
					</CreateBase>
				</DialogContent>
			</Dialog>
		</>
	);
};
